export class GetSalesRepresentativesRequest {
    ActiveOnly: boolean;
    CurrentSalesRepID?: number;
}
